import React from "react";
import MuiIcon from "@material-ui/core/Icon";
import PropTypes from "prop-types";

/**
 * Icon component wrapper for Material Icons.
 * Wraps Material-UI Icon with theme integration.
 * 
 * @component
 * @example
 * <Icon>home</Icon>
 * <Icon color="primary">star</Icon>
 * <Icon fontSize="large">favorite</Icon>
 */
const Icon = ({ children, ...props }) => {
  return <MuiIcon {...props}>{children}</MuiIcon>;
};

Icon.propTypes = {
  /**
   * The name of the icon font ligature
   */
  children: PropTypes.node,
  /**
   * The base class applied to the icon
   */
  baseClassName: PropTypes.string,
  /**
   * The color of the component
   */
  color: PropTypes.oneOf([
    "inherit",
    "action",
    "disabled",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  /**
   * The fontSize applied to the icon
   */
  fontSize: PropTypes.oneOf(["inherit", "large", "medium", "small"]),
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Icon behavior
// MUI Icon defaults: color="inherit", fontSize="medium", baseClassName="material-icons"

export default Icon;

